import type { FC } from 'react';
import { useMemo } from 'react';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AspectRatioWarning } from '@/features/media/components/AspectRatioWarning';
import { isOrganizationImageAspectRatioAcceptable } from '@/features/media/utils/imageAspectRatio';
import type { OrganizationEditFormValues } from '@/features/profile-setting/components/organization-edit/types';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

export const DetailImageAspectRatioWarning: FC = () => {
  const { t } = useTranslation(LocalizationNameSpace.PROFILE_SETTING, {
    keyPrefix: 'screens.organization-edit'
  });
  const { control } = useFormContext<OrganizationEditFormValues>();

  const detailImages = useWatch({ control, name: 'detailImages' });
  const { errors } = useFormState({ control, name: 'detailImages' });

  const showWarning = useMemo(
    () =>
      (detailImages ?? []).some(
        (entry, index) =>
          !errors.detailImages?.[index]?.message &&
          !isOrganizationImageAspectRatioAcceptable(
            entry?.asset?.width,
            entry?.asset?.height
          )
      ),
    [detailImages, errors.detailImages]
  );

  if (!showWarning) {
    return <></>;
  }

  return <AspectRatioWarning message={t('warnings.imageAspectRatio')} />;
};
